export default "__VITE_ASSET__6884be45__"